import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import picture1 from "./application.png";
import Swal from "sweetalert2";
import CommonModal from "../../../core/common/CommonModal";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import logo from "../../../images/logo.png";
import GeneralInformation from "./GeneralInformation";
import BackgroundCheckProcess from "./BackgroundCheckProcess";
import PrivacyRights from "./PrivacyRights";
import PrivacyRequests from "./PrivacyRequests";
import { useAuth } from "../../auth/AuthContext";
import Footer from "../../../core/common/footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import dummyLogo from "../../../images/dummyLogo.png";
import useApi from "../../../core/customhook/useApi";
import { getDashboard } from "../../../environment";
import { setDashboardData } from "../../../core/data/redux/dashboardSlice";
import { RootState } from "../../../core/data/redux/store";
import WelcomePopup from "./WelcomePopup";
import InsuffRaise from "./InsuffRaise";

const CaseComponent = () => {
  const routes = all_routes;
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState("general");
  const [privacyTab, setPrivacyTab] = useState("privacy_request");
  const [showPackageModal, setShowPackageModal] = useState(false);
  const [privacyModalType, setPrivacyModalType] = useState<
    | "background"
    | "copyReport"
    | "deleteReport"
    | "disputeReport"
    | "stopReport"
  >("background");
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const packageStatus = useSelector(
    (state: RootState) => state?.package?.status,
  );
  const reduxDashboardData = useSelector(
    (state: any) => state?.dashboard?.dashboardData,
  );

  const getDashboardAPI = useApi<any>(getDashboard, {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

  const dashboardData = async () => {
    try {
      const response = await getDashboardAPI.callApi();

      if (response?.success) {
        dispatch(setDashboardData(response.data));
      }
    } catch (error) {
      console.error("Error fetching dashboard:", error);
    }
  };

  useEffect(() => {
    dashboardData();
  }, []);

  useEffect(() => {
    const popupShown = sessionStorage.getItem("welcomePopupShown");

    if (!popupShown) {
      setShowWelcomePopup(true);
      sessionStorage.setItem("welcomePopupShown", "true");
    }
  }, []);

  const handleClosePopup = () => {
    setShowWelcomePopup(false);
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Logout?",
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
        sessionStorage.removeItem("welcomePopupShown");
        navigate(routes.login);
      }
    });
  };

  const viewApplicationStatuses = [
    "VERIFICATION_IN_PROGRESS",
    "VERIFIED",
    "MAJOR_DISCREPANCY",
    "MINOR_DISCREPANCY",
    "UNABLE_TO_VERIFY",
    "NA",
    "WORK IN PROGRESS",
    "SUBMITED",
  ];

  return (
    <>
      {showWelcomePopup && <WelcomePopup onClose={handleClosePopup} />}
      {/* Header */}
      <div className="header w-full" style={{ left: "0px", height: "60px" }}>
        <div className="main-header">
          <div className="header-left">
            <Link to={routes.adminDashboard} className="logo">
              <ImageWithBasePath src={logo} alt="Logo" />
            </Link>
            <Link to={routes.adminDashboard} className="dark-logo">
              <ImageWithBasePath src={logo} alt="Logo" />
            </Link>
          </div>

          <div className="header-user case-custome-header">
            <div className="nav user-menu nav-list d-flex justify-content-between align-items-center">
              <div>
                <img
                  src={logo}
                  alt="logo"
                  style={{ height: "50px" }}
                  className="w-auto"
                />
              </div>

              <div className="d-flex align-items-center gap-4">
                <div
                  className="me-auto d-flex align-items-center"
                  id="header-search"
                >
                  <p className="text-dark">
                    <b>
                      Client Name:{" "}
                      {reduxDashboardData?.assignmentDetails?.organization_name}
                    </b>
                  </p>
                </div>

                <div className="d-flex align-items-center gap-3 fw-bold text-dark me-4">
                  <div
                    onClick={() => navigate(all_routes.faq)}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    FAQ
                  </div>

                  <div
                    style={{
                      width: "1px",
                      height: "20px",
                      backgroundColor: "#000",
                    }}
                  ></div>

                  <div
                    onClick={() => navigate(all_routes.support)}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    Support
                  </div>
                  {/* 
                  <div
                    style={{
                      width: "1px",
                      height: "20px",
                      backgroundColor: "#000",
                    }}
                  ></div>

                  <div>{reduxDashboardData?.assignmentDetails?.full_name}</div> */}
                </div>
                <div className="dropdown profile-dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle d-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <span className="avatar avatar-sm online">
                      <img
                        src={dummyLogo}
                        alt="Img"
                        className="img-fluid rounded-circle"
                      />
                    </span>
                  </Link>
                  <div className="dropdown-menu shadow-none mt-1">
                    <div className="card mb-0">
                      <div className="card-header">
                        <div className="d-flex align-items-center">
                          <span className="avatar avatar-lg me-2 avatar-rounded">
                            <ImageWithBasePath src={dummyLogo} alt="img" />
                          </span>
                          <div>
                            <h5 className="mb-0">
                              {reduxDashboardData?.assignmentDetails?.full_name}
                            </h5>
                            <p className="fs-12 fw-medium mb-0">
                              {reduxDashboardData?.assignmentDetails?.email}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <Link
                          className="dropdown-item d-inline-flex align-items-center p-0"
                          to={routes.profile}
                        >
                          <i className="ti ti-user-circle me-1"></i>My Profile
                        </Link>
                      </div>
                      <div className="card-footer">
                        <button
                          className="dropdown-item d-inline-flex align-items-center p-0"
                          onClick={handleLogout}
                        >
                          <i className="ti ti-login me-2"></i>Logout
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="dropdown mobile-user-menu">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v"></i>
            </Link>
            <div className="dropdown-menu dropdown-menu-end">
              <Link className="dropdown-item" to={routes.profile}>
                My Profile
              </Link>
              <button className="dropdown-item" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* /Header */}

      <div className="container my-4 bg-white verification-page-margin">
        <div className="card p-3">
          <div className="row align-items-center mb-3">
            <div className="col-lg-9 col-md-8 col-12">
              <div className="case_top mb-3">
                <span className="dashboard-pill">
                  <i className="ti ti-id me-1"></i>
                  Case ID: {reduxDashboardData?.assignmentDetails?.case_id}
                </span>

                <span className="verticalLine">|</span>

                <span className="dashboard-pill">
                  <i className="ti ti-user me-1"></i>
                  Client Name:{" "}
                  {reduxDashboardData?.assignmentDetails?.organization_name}
                </span>
              </div>

              <h1 className="verification_Hd">
                Welcome to Aupertz Background Verification Dashboard
              </h1>

              <div className="mt-3">
                <div className="status-row mb-2">
                  <span className="status-label">
                    Applicant Submission Status:
                  </span>
                  {reduxDashboardData?.assignmentDetails?.package_status ===
                  "SUBMITED" ? (
                    <span className="status-badge status-badge-success">
                      <i className="ti ti-circle-check-filled me-1"></i>
                      {reduxDashboardData?.assignmentDetails?.package_status}
                    </span>
                  ) : reduxDashboardData?.assignmentDetails?.package_status ===
                    "WORK IN PROGRESS" ? (
                    <span className="status-badge status-badge-warning">
                      <i className="ti ti-clock-hour-4 me-1"></i>
                      {reduxDashboardData?.assignmentDetails?.package_status}
                    </span>
                  ) : reduxDashboardData?.assignmentDetails?.package_status ? (
                    <span className="status-badge status-badge-secondary">
                      {reduxDashboardData?.assignmentDetails?.package_status}
                    </span>
                  ) : (
                    <span className="status-badge status-badge-secondary">
                      Status Not Available
                    </span>
                  )}
                </div>

                <div className="status-row">
                  <span className="status-label">Package Ordered:</span>
                  <span
                    className="status-view-link"
                    onClick={() => setShowPackageModal(true)}
                  >
                    <i className="ti ti-eye me-1"></i>
                    View
                  </span>
                </div>
              </div>

              {/* CASE DETAILS */}
              <div className="mt-4">
                <h6 className="case-details-heading mb-3">Case Details</h6>
                <div className="info-card-grid">
                  <div className="info-card">
                    <div className="info-card-icon">
                      <i className="ti ti-calendar-event"></i>
                    </div>
                    <div>
                      <small>Invite Date</small>
                      <h6>
                        {reduxDashboardData?.assignmentDetails?.invite_date
                          ? new Date(
                              reduxDashboardData.assignmentDetails.invite_date,
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : "-"}
                      </h6>
                    </div>
                  </div>
                  <div className="info-card">
                    <div className="info-card-icon">
                      <i className="ti ti-calendar-event"></i>
                    </div>
                    <div>
                      <small>Start Date</small>
                      <h6>
                        {reduxDashboardData?.assignmentDetails?.start_date
                          ? new Date(
                              reduxDashboardData.assignmentDetails.start_date,
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : "-"}
                      </h6>
                    </div>
                  </div>

                  <div className="info-card">
                    <div className="info-card-icon">
                      <i className="ti ti-calendar-event"></i>
                    </div>
                    <div>
                      <small>Expected Closure Date</small>
                      <h6>
                        {reduxDashboardData?.assignmentDetails
                          ?.expected_closure_date
                          ? new Date(
                              reduxDashboardData.assignmentDetails
                                .expected_closure_date,
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : "-"}
                      </h6>
                    </div>
                  </div>

                  <div className="info-card">
                    <div className="info-card-icon">
                      <i className="ti ti-calendar-event"></i>
                    </div>
                    <div>
                      <small>Completion Date</small>
                      <h6>
                        {reduxDashboardData?.assignmentDetails?.completion_date
                          ? new Date(
                              reduxDashboardData.assignmentDetails
                                .completion_date,
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : "-"}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-12 text-center text-md-end mt-3 mt-md-0">
              <img
                src={picture1}
                alt="Illustration"
                className="img-fluid mb-2 application_image"
              />

              {viewApplicationStatuses.includes(
                reduxDashboardData?.assignmentDetails?.package_status,
              ) ? (
                <button
                  onClick={() => navigate(all_routes.superAdminDashboard)}
                  className="btn btn-success"
                >
                  <i className="ti ti-eye me-2"></i>
                  View Application Form
                </button>
              ) : (
                <button
                  onClick={() => navigate(all_routes.superAdminDashboard)}
                  className="btn btn-primary"
                >
                  <i className="ti ti-file-pencil me-2"></i>
                  Fill Application Form
                </button>
              )}
            </div>
          </div>

          {reduxDashboardData?.assignmentDetails?.package_status ===
            "INSUFF" && <InsuffRaise />}
        </div>

        {/* SPECIAL INSTRUCTIONS */}
        {/* <div className="border rounded p-3 mt-4">
          <div
            style={{
              width: "100%",
              borderBottom: "2px solid #dc3545",
              position: "relative",
              marginBottom: "20px",
            }}
          >
            <span
              className="bg-white px-2 fw-semibold text-danger"
              style={{
                position: "absolute",
                top: "-12px",
                left: "20px",
                fontSize: "14px",
              }}
            >
              Special Instructions
            </span>
          </div>
          <div className="col-md-6 d-flex border-bottom pb-2 gap-3 mb-4">
            <button className={`btn custom-tab-btn custom-tab-active`}>
              Special Instructions
            </button>
          </div>

          <p className="mb-0">
            <strong className="text-dark">Remarks:</strong>{" "}
            <b className="text-dark">N/A</b>
          </p>
        </div> */}

        {/* TABS SECTION */}
        <div className="border rounded p-3 mt-4">
          {/* TAB HEADERS */}
          <div className="d-flex border-bottom pb-2 gap-3 mb-4">
            <button
              className={`btn custom-tab-btn ${
                activeTab === "general" ? "custom-tab-active" : "text-dark"
              }`}
              onClick={() => setActiveTab("general")}
            >
              General Information
            </button>

            <button
              className={`btn custom-tab-btn ${
                activeTab === "background" ? "custom-tab-active" : "text-dark"
              }`}
              onClick={() => setActiveTab("background")}
            >
              Background Check Process
            </button>
          </div>

          {/* TAB CONTENT */}
          {activeTab === "general" && <GeneralInformation />}

          {activeTab === "background" && <BackgroundCheckProcess />}
        </div>

        {/* TABS SECTION */}
        <div className="border rounded p-3 mt-4">
          {/* TAB HEADERS */}
          <div className="d-flex border-bottom pb-2 gap-3 mb-4">
            <button
              className={`btn custom-tab-btn ${
                privacyTab === "privacy_request"
                  ? "custom-tab-active"
                  : "text-dark"
              }`}
              onClick={() => setPrivacyTab("privacy_request")}
            >
              Privacy Requests
            </button>

            <button
              className={`btn custom-tab-btn ${
                privacyTab === "privacy_right"
                  ? "custom-tab-active"
                  : "text-dark"
              }`}
              onClick={() => setPrivacyTab("privacy_right")}
            >
              Privacy Rights
            </button>
          </div>

          {/* TAB CONTENT */}
          {privacyTab === "privacy_request" && <PrivacyRequests />}

          {privacyTab === "privacy_right" && <PrivacyRights />}
        </div>

        <div className="border rounded p-3 mt-4">
          <p>
            The access and Login to the portal is restricted by Unique Password
            Login and Aupertz accepts no liability for any data misuse from your
            Unique Login Details. The Login Details are Confidential. Kindly do
            not share the same with anyone else. Kindly change your Password at
            frequent intervals to avoid misuse / circulation
          </p>

          <div
            className="d-flex flex-wrap justify-content-between align-items-center p-3 rounded"
            style={{ backgroundColor: "#10304d", color: "#ffff" }}
          >
            {" "}
            <p className="m-0">
              User Name: {reduxDashboardData?.assignmentDetails?.full_name}
            </p>
            <p className="m-0">
              Account Id: {reduxDashboardData?.assignmentDetails?.case_id}
            </p>
            <p className="m-0">
              Last Login:{" "}
              {reduxDashboardData?.assignmentDetails?.last_login_at
                ? new Date(
                    reduxDashboardData.assignmentDetails.last_login_at,
                  ).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })
                : "-"}
            </p>
          </div>
        </div>
      </div>
      <Footer />
      <CommonModal
        show={showPackageModal || showPrivacyModal}
        onClose={() => {
          setShowPackageModal(false);
          setShowPrivacyModal(false);
        }}
        modalType={showPackageModal ? "background" : privacyModalType}
      />
    </>
  );
};

export default CaseComponent;

// import { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import picture1 from "./application.png";
// import Swal from "sweetalert2";
// import CommonModal from "../../../core/common/CommonModal";
// import { all_routes } from "../../router/all_routes";
// import ImageWithBasePath from "../../../core/common/imageWithBasePath";
// import logo from "../../../images/logo.png";
// import GeneralInformation from "./GeneralInformation";
// import BackgroundCheckProcess from "./BackgroundCheckProcess";
// import PrivacyRights from "./PrivacyRights";
// import PrivacyRequests from "./PrivacyRequests";
// import { useAuth } from "../../auth/AuthContext";
// import Footer from "../../../core/common/footer/Footer";
// import { useDispatch, useSelector } from "react-redux";
// import dummyLogo from "../../../images/dummyLogo.png";
// import useApi from "../../../core/customhook/useApi";
// import { getDashboard } from "../../../environment";
// import { setDashboardData } from "../../../core/data/redux/dashboardSlice";
// import { RootState } from "../../../core/data/redux/store";
// import WelcomePopup from "./WelcomePopup";
// import InsuffRaise from "./InsuffRaise";
// import "./CaseComponent.css"; // UI-only styles (new)

// const CaseComponent = () => {
//   const routes = all_routes;
//   const { logout } = useAuth();
//   const [activeTab, setActiveTab] = useState("general");
//   const [privacyTab, setPrivacyTab] = useState("privacy_request");
//   const [showPackageModal, setShowPackageModal] = useState(false);
//   const [privacyModalType, setPrivacyModalType] = useState<
//     | "background"
//     | "copyReport"
//     | "deleteReport"
//     | "disputeReport"
//     | "stopReport"
//   >("background");
//   const [showPrivacyModal, setShowPrivacyModal] = useState(false);
//   const [showWelcomePopup, setShowWelcomePopup] = useState(false);

//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const packageStatus = useSelector(
//     (state: RootState) => state?.package?.status,
//   );
//   const reduxDashboardData = useSelector(
//     (state: any) => state?.dashboard?.dashboardData,
//   );

//   const getDashboardAPI = useApi<any>(getDashboard, {
//     method: "GET",
//     autoCall: false,
//     handleGlobalError: false,
//   });

//   const dashboardData = async () => {
//     try {
//       const response = await getDashboardAPI.callApi();

//       if (response?.success) {
//         dispatch(setDashboardData(response.data));
//       }
//     } catch (error) {
//       console.error("Error fetching dashboard:", error);
//     }
//   };

//   useEffect(() => {
//     dashboardData();
//   }, []);

//   useEffect(() => {
//     const popupShown = sessionStorage.getItem("welcomePopupShown");

//     if (!popupShown) {
//       setShowWelcomePopup(true);
//       sessionStorage.setItem("welcomePopupShown", "true");
//     }
//   }, []);

//   const handleClosePopup = () => {
//     setShowWelcomePopup(false);
//   };

//   const handleLogout = () => {
//     Swal.fire({
//       title: "Logout?",
//       text: "Are you sure you want to logout?",
//       icon: "warning",
//       showCancelButton: true,
//     }).then((result) => {
//       if (result.isConfirmed) {
//         logout();
//         sessionStorage.removeItem("welcomePopupShown");
//         navigate(routes.login);
//       }
//     });
//   };

//   // ---- UI helpers (display only) ----
//   const details = reduxDashboardData?.assignmentDetails;
//   const formatDate = (value?: string) =>
//     value
//       ? new Date(value).toLocaleDateString("en-IN", {
//           day: "2-digit",
//           month: "short",
//           year: "numeric",
//         })
//       : "-";

//   const timeline = [
//     { label: "Invite Date", value: details?.invite_date },
//     { label: "Start Date", value: details?.start_date },
//     { label: "Expected Closure Date", value: details?.expected_closure_date },
//     { label: "Completion Date", value: details?.completion_date },
//   ];

//   return (
//     <>
//       {showWelcomePopup && <WelcomePopup onClose={handleClosePopup} />}
//       {/* Header */}
//       <div className="header w-full" style={{ left: "0px", height: "70px" }}>
//         <div className="main-header">
//           <div className="header-left">
//             <Link to={routes.adminDashboard} className="logo">
//               <ImageWithBasePath src={logo} alt="Logo" />
//             </Link>
//             <Link to={routes.adminDashboard} className="dark-logo">
//               <ImageWithBasePath src={logo} alt="Logo" />
//             </Link>
//           </div>

//           <div className="header-user case-custome-header">
//             <div className="nav user-menu nav-list d-flex justify-content-between align-items-center">
//               <div>
//                 <img
//                   src={logo}
//                   alt="logo"
//                   style={{ height: "50px" }}
//                   className="w-auto"
//                 />
//               </div>

//               <div className="d-flex align-items-center gap-4">
//                 <div
//                   className="me-auto d-flex align-items-center"
//                   id="header-search"
//                 >
//                   <span className="cv-client-chip">
//                     <i className="ti ti-building"></i>
//                     Client Name: {details?.organization_name}
//                   </span>
//                 </div>

//                 <div className="cv-header-links me-2">
//                   <div
//                     className="cv-hl"
//                     role="button"
//                     tabIndex={0}
//                     onClick={() => navigate(all_routes.faq)}
//                   >
//                     FAQ
//                   </div>

//                   <div className="cv-sep"></div>

//                   <div
//                     className="cv-hl"
//                     role="button"
//                     tabIndex={0}
//                     onClick={() => navigate(all_routes.support)}
//                   >
//                     Support
//                   </div>
//                   {/*
//                   <div>{reduxDashboardData?.assignmentDetails?.full_name}</div> */}
//                 </div>
//                 <div className="dropdown profile-dropdown">
//                   <Link
//                     to="#"
//                     className="dropdown-toggle d-flex align-items-center"
//                     data-bs-toggle="dropdown"
//                   >
//                     <span className="avatar avatar-sm online">
//                       <img
//                         src={dummyLogo}
//                         alt="Img"
//                         className="img-fluid rounded-circle"
//                       />
//                     </span>
//                   </Link>
//                   <div className="dropdown-menu shadow-none mt-1">
//                     <div className="card mb-0">
//                       <div className="card-header">
//                         <div className="d-flex align-items-center">
//                           <span className="avatar avatar-lg me-2 avatar-rounded">
//                             <ImageWithBasePath src={dummyLogo} alt="img" />
//                           </span>
//                           <div>
//                             <h5 className="mb-0">{details?.full_name}</h5>
//                             <p className="fs-12 fw-medium mb-0">
//                               {details?.email}
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="card-body">
//                         <Link
//                           className="dropdown-item d-inline-flex align-items-center p-0"
//                           to={routes.profile}
//                         >
//                           <i className="ti ti-user-circle me-1"></i>My Profile
//                         </Link>
//                       </div>
//                       <div className="card-footer">
//                         <button
//                           className="dropdown-item d-inline-flex align-items-center p-0"
//                           onClick={handleLogout}
//                         >
//                           <i className="ti ti-login me-2"></i>Logout
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="dropdown mobile-user-menu">
//             <Link
//               to="#"
//               className="nav-link dropdown-toggle"
//               data-bs-toggle="dropdown"
//               aria-expanded="false"
//             >
//               <i className="fa fa-ellipsis-v"></i>
//             </Link>
//             <div className="dropdown-menu dropdown-menu-end">
//               <Link className="dropdown-item" to={routes.profile}>
//                 My Profile
//               </Link>
//               <button className="dropdown-item" onClick={handleLogout}>
//                 Logout
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* /Header */}

//       <div className="container my-4 verification-page-margin cv-page">
//         {/* HERO */}
//         <div className="cv-hero">
//           <div className="row g-0 align-items-stretch">
//             <div className="col-lg-9 col-md-8 col-12">
//               <div className="cv-hero-main">
//                 <div className="cv-pills">
//                   <span className="cv-pill">
//                     <i className="ti ti-id"></i>
//                     Case ID: {details?.case_id}
//                   </span>
//                   <span className="cv-pill">
//                     <i className="ti ti-user"></i>
//                     Client Name: {details?.organization_name}
//                   </span>
//                 </div>

//                 <h1 className="cv-title">
//                   Welcome to Aupertz Background Verification Dashboard
//                 </h1>

//                 <div className="cv-status-grid">
//                   <div className="cv-status-item">
//                     <span className="cv-status-label">
//                       Applicant Submission Status
//                     </span>
//                     {details?.package_status === "SUBMITED" ? (
//                       <span className="cv-badge cv-badge-success">
//                         <i className="ti ti-circle-check-filled"></i>
//                         {details?.package_status}
//                       </span>
//                     ) : details?.package_status === "WORK IN PROGRESS" ? (
//                       <span className="cv-badge cv-badge-warning">
//                         <i className="ti ti-clock-hour-4"></i>
//                         {details?.package_status}
//                       </span>
//                     ) : details?.package_status ? (
//                       <span className="cv-badge cv-badge-secondary">
//                         {details?.package_status}
//                       </span>
//                     ) : (
//                       <span className="cv-badge cv-badge-secondary">
//                         Status Not Available
//                       </span>
//                     )}
//                   </div>

//                   <div className="cv-status-item">
//                     <span className="cv-status-label">Package Ordered</span>
//                     <span
//                       className="cv-link"
//                       role="button"
//                       tabIndex={0}
//                       onClick={() => setShowPackageModal(true)}
//                     >
//                       <i className="ti ti-eye"></i>
//                       View
//                     </span>
//                   </div>
//                 </div>

//                 {/* CASE DETAILS */}
//                 <h6 className="cv-section-title">Case Details</h6>
//                 <div className="cv-timeline">
//                   {timeline.map((item) => (
//                     <div
//                       key={item.label}
//                       className={`cv-step ${item.value ? "is-done" : ""}`}
//                     >
//                       <span className="cv-step-dot"></span>
//                       <small>{item.label}</small>
//                       <h6>{formatDate(item.value)}</h6>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             <div className="col-lg-3 col-md-4 col-12">
//               <div className="cv-hero-aside">
//                 <img
//                   src={picture1}
//                   alt="Illustration"
//                   className="img-fluid application_image"
//                 />

//                 {details?.package_status === "SUBMITED" ? (
//                   <button
//                     onClick={() => navigate(all_routes.superAdminDashboard)}
//                     className="btn btn-success cv-cta"
//                   >
//                     <i className="ti ti-eye me-2"></i>
//                     View Application Form
//                   </button>
//                 ) : (
//                   <button
//                     onClick={() => navigate(all_routes.superAdminDashboard)}
//                     className="btn btn-primary cv-cta"
//                   >
//                     <i className="ti ti-file-pencil me-2"></i>
//                     Fill Application Form
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>

//           {details?.package_status === "INSUFF" && (
//             <div className="p-3 border-top">
//               <InsuffRaise />
//             </div>
//           )}
//         </div>

//         {/* TABS SECTION 1 */}
//         <div className="cv-panel">
//           <div className="cv-tabs">
//             <button
//               className={`btn custom-tab-btn ${
//                 activeTab === "general" ? "custom-tab-active" : "text-dark"
//               }`}
//               onClick={() => setActiveTab("general")}
//             >
//               General Information
//             </button>

//             <button
//               className={`btn custom-tab-btn ${
//                 activeTab === "background" ? "custom-tab-active" : "text-dark"
//               }`}
//               onClick={() => setActiveTab("background")}
//             >
//               Background Check Process
//             </button>
//           </div>

//           {activeTab === "general" && <GeneralInformation />}
//           {activeTab === "background" && <BackgroundCheckProcess />}
//         </div>

//         {/* TABS SECTION 2 */}
//         <div className="cv-panel">
//           <div className="cv-tabs">
//             <button
//               className={`btn custom-tab-btn ${
//                 privacyTab === "privacy_request"
//                   ? "custom-tab-active"
//                   : "text-dark"
//               }`}
//               onClick={() => setPrivacyTab("privacy_request")}
//             >
//               Privacy Requests
//             </button>

//             <button
//               className={`btn custom-tab-btn ${
//                 privacyTab === "privacy_right"
//                   ? "custom-tab-active"
//                   : "text-dark"
//               }`}
//               onClick={() => setPrivacyTab("privacy_right")}
//             >
//               Privacy Rights
//             </button>
//           </div>

//           {privacyTab === "privacy_request" && <PrivacyRequests />}
//           {privacyTab === "privacy_right" && <PrivacyRights />}
//         </div>

//         {/* SECURITY NOTICE + ACCOUNT BAR */}
//         <div className="cv-notice">
//           <i className="ti ti-shield-lock"></i>
//           <div className="flex-grow-1">
//             <p>
//               The access and Login to the portal is restricted by Unique
//               Password Login and Aupertz accepts no liability for any data
//               misuse from your Unique Login Details. The Login Details are
//               Confidential. Kindly do not share the same with anyone else.
//               Kindly change your Password at frequent intervals to avoid misuse
//               / circulation
//             </p>

//             <div className="cv-account-bar">
//               <div>
//                 <span>User Name</span>
//                 <b>{details?.full_name}</b>
//               </div>
//               <div>
//                 <span>Account Id</span>
//                 <b>{details?.case_id}</b>
//               </div>
//               <div>
//                 <span>Last Login</span>
//                 <b>
//                   {details?.last_login_at
//                     ? new Date(details.last_login_at).toLocaleString("en-IN", {
//                         day: "2-digit",
//                         month: "short",
//                         year: "numeric",
//                         hour: "2-digit",
//                         minute: "2-digit",
//                         hour12: true,
//                       })
//                     : "-"}
//                 </b>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Footer />
//       <CommonModal
//         show={showPackageModal || showPrivacyModal}
//         onClose={() => {
//           setShowPackageModal(false);
//           setShowPrivacyModal(false);
//         }}
//         modalType={showPackageModal ? "background" : privacyModalType}
//       />
//     </>
//   );
// };

// export default CaseComponent;
